import React, { forwardRef } from "react";
import { Button, Chip, Typography } from "@mui/material";
import { func, string } from "prop-types";

interface ButtonInputProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  componentLabel?: string;
  value?: string;
  [key: string]: any;
}

const ButtonInput = forwardRef<HTMLButtonElement, ButtonInputProps>(
  (props, ref) => {
    return (
      <Button
        type={"button"}
        onClick={props.onClick}
        ref={ref}
        sx={{ color: "secondary" }}
      >
        <Typography
          sx={{
            color: "secondary.800",
            fontWeight: "fontWeightMedium",
            fontSize: "14px",
          }}
        >
          {props.componentLabel}
        </Typography>
        <Chip
          sx={{
            ml: 0.5,
            backgroundColor: "primary.50",
            color: "primary.main",
            fontSize: "14px",
          }}
          size="small"
          label={<Typography>{props.value}</Typography>}
        />
      </Button>
    );
  },
);

ButtonInput.displayName = "ButtonInput";
ButtonInput.propTypes = {
  onClick: func,
  componentLabel: string,
  value: string,
};

export default ButtonInput;
